import React, { useState, useEffect } from 'react';
import useAuthStore from '../stores/useAuthStore';
import DashboardLayout from '../components/DashboardLayout';
import axiosClient from '../services/api';

const StudentBillingPage = () => {
  const { user } = useAuthStore();
  const [enrollments, setEnrollments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBillingHistory = async () => {
      try {
        const res = await axiosClient.get('/courses/enrollments/my-enrollments');
        setEnrollments(res.data.enrollments);
      } catch (err) {
        console.error('Failed to fetch billing history');
      } finally {
        setIsLoading(false);
      }
    };
    fetchBillingHistory();
  }, []);

  return (
    <DashboardLayout userRole={user.role}>
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-neutral-900 dark:text-white">Billing History</h1>
            <p className="text-neutral-600 dark:text-neutral-400 mt-2">
              View your course purchases and payment details
            </p>
          </div>

          {isLoading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
            </div>
          ) : enrollments?.length === 0 ? (
            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 p-8 text-center">
              <div className="text-6xl mb-4">💳</div>
              <h3 className="text-xl font-semibold text-neutral-900 dark:text-white mb-2">No purchases yet</h3>
              <p className="text-neutral-600 dark:text-neutral-400">
                Enroll in a course to start your learning journey.
              </p>
            </div>
          ) : (
            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 overflow-hidden">
              <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-700">
                <thead className="bg-neutral-50 dark:bg-neutral-700">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Course</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Amount</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Status</th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-neutral-800 divide-y divide-neutral-200 dark:divide-neutral-700">
                  {enrollments?.map(enrollment => (
                    <tr key={enrollment?._id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <img 
                            src={`${process.env.REACT_APP_SOCKET_URL}${enrollment?.course?.thumbnail}`} 
                            alt={enrollment?.course?.title}
                            className="w-10 h-10 rounded mr-3"
                          />
                          <div>
                            <div className="font-medium text-neutral-900 dark:text-white">
                              {enrollment?.course?.title}
                            </div>
                            {enrollment.coupon && (
                              <div className="text-xs text-primary-600 dark:text-primary-400">
                                Coupon applied
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-neutral-900 dark:text-white">
                        {enrollment?.createdAt ? new Date(enrollment.createdAt).toLocaleDateString() : 'N/A'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-neutral-900 dark:text-white">
                       ₦{enrollment?.amountPaid?.toLocaleString('en-NG')}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
                          Paid
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default StudentBillingPage;